import { Select, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./paymentIntrumentSelection.css";
import { CheckCircleFilled, CloseCircleOutlined, DeleteOutlined, DeleteTwoTone, RightOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { colorShadesGenerator, generateDynamicStyling, isEmpty, numberToCurrency } from "../../../../Utils/utils";
import { TOP_BANKS } from "../../../../staticData";
import {
  selectBaseColor,
  selectCurrencyCode,
} from "../../../../slices/PaymentSessionDetailsSlice";
import {
  deleteSavedInstruments,
  selectSelectedIntrument,
  updateSelectedInstruments,
  removeDeletedInstrument,
  getSavedIntsruments
} from "../../../../slices/SavedInstrumentSlice";
import { selectIsMobileLayout } from "../../../../slices/MobileLayoutSlice";
import {
  handleDurationValue,
  handleEMICode,
  handleEmiPayButton,
} from "../../../../slices/EmiSlice";
import EmiPlanDetails from "../emi/emiPlanDetails";
import {
  methodSelectedEvent,
  deleteSavedCardModalClickedEvent,
  deleteSavedCardModalClosedEvent,
  saveCardRemovedEvent,
} from "../../../../Utils/uiAnalytics";
import { handleTotalPaymentSummaryError } from "../../../../slices/HandleAdditionalComponentsSlice";
import {
  changeUpiVpa,
  handleIdForButton,
  handleUpiError,
  resetUpiFields,
  selectUpiButtonId,
  setUpiType,
} from "../../../../slices/UpiSlice";
import TranslateText from "../../../resuableComponents/TranslateText";
import PyamentButton from "../../paymentButton/PaymentButton";
import { selectActivePaymentMethod } from "../../../../slices/PaymentButtonSlice";
import ConfirmationModal from "../../modals/ConfirmationModal";
import { selectMobileNumber } from "../../../../slices/ShopperInfoSlice";

const PaymentIntrumentSelection = ({
  data,
  searchComponent,
  searchPlaceholder,
  showUpiPayButton = false,
  afterList = null,
}) => {
  const { t } = useTranslation();
  const isMobileLayout = useSelector((state) => selectIsMobileLayout(state));
  const [selectedIntrumentIdx, setSelectedInstrumentIdx] = useState(null);
  const baseColor = useSelector((state) => selectBaseColor(state));
  const currencyCode = useSelector((state) => selectCurrencyCode(state));
  const sessionDetails = useSelector((state) => state.paymentSessionDetails.sessionDetails);
  const selectedInstrument = useSelector((state) => selectSelectedIntrument(state));
  const activePaymentMethod = useSelector((state) => selectActivePaymentMethod(state));
  const isLoggedIn = useSelector((state) => state.shopperInfo.isLoggedIn);
  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false)
  const [deleteInstrumentData, setDeleteInstrumentData] = useState();
  const deletedInstrument = useSelector(state => state.savedInstrument.deletedInstrument);
  const deleteInstrumentsLoading = useSelector(state => state.savedInstrument.deleteInstrumentsLoading);
  const shopperRef = useSelector((state) => selectMobileNumber(state));
  const sessionDetailsLoaded = useSelector((state) => state.paymentSessionDetails.sessionDetailsLoaded);



  const dispatch = useDispatch();
  useEffect(() => {
    if (sessionDetails) {
      generateDynamicStyling(sessionDetails);
    }
  }, [sessionDetails]);

  useEffect(() => {
    if (selectedInstrument) {
      let index = null;
      if (selectedInstrument?.brand === "CardlessEMI") {
        index = data?.findIndex(
          (val) =>
            val?.emiMethod?.cardlessEmiProviderValue ===
            selectedInstrument?.emiMethod?.cardlessEmiProviderValue
        );
      } else if (
        selectedInstrument?.emiMethod?.brand === "CreditCardEMI" ||
        selectedInstrument?.emiMethod?.brand === "DebitCardEMI"
      ) {
        index = data?.findIndex(
          (val) =>
            val?.emiMethod?.duration === selectedInstrument?.emiMethod?.duration
        );

        dispatch(
          handleEMICode(selectedInstrument?.emiMethod?.applicableOffer?.code)
        );
        dispatch(handleDurationValue(selectedInstrument?.emiMethod?.duration));
      } else {
        index = data?.findIndex((val) =>
          selectedInstrument?.value
            ? val?.value === selectedInstrument?.value
            : val?.brand === selectedInstrument?.brand
        );
        if (selectedInstrument?.type === "Upi" && selectedInstrument?.value) {
          dispatch(handleIdForButton("savedVpa"));
          dispatch(changeUpiVpa(selectedInstrument?.value));
          dispatch(handleUpiError(""));
          if (selectedInstrument?.brand) {
            dispatch(setUpiType(selectedInstrument?.brand));
          }
        }
      }
      setSelectedInstrumentIdx(index);
    } else if (data?.length !== 1) {
      dispatch(changeUpiVpa(""));
      dispatch(handleUpiError(""));
      setSelectedInstrumentIdx(null);
      dispatch(resetUpiFields());
    }
  }, [selectedInstrument]);

  // useEffect(() => {
  //   if (data?.length === 1) {
  //     const singleInstrument = data[0];
  //     setSelectedInstrumentIdx(singleInstrument);
  //   }
  // }, [data, dispatch]);

  // useEffect(() => {
  //   if (data?.length === 1 && selectedIntrumentIdx) {
  //     dispatch(updateSelectedInstruments(selectedIntrumentIdx));
  //   }
  // }, [data, selectedIntrumentIdx, dispatch]);

  const handleDeleteInstrumentClick = (paymentInfo) => {
    deleteSavedCardModalClickedEvent();
    setDeleteInstrumentData(paymentInfo)
    setIsDeleteConfirmationModalOpen(true);

  }


  const handleDeleteConfirmation = () => {
    saveCardRemovedEvent();
    let instrumentRef = deleteInstrumentData?.instrumentRef;
    let type = deleteInstrumentData?.type;
    let checkoutToken = sessionDetails?.token;

    let payload = {
      type: type,
      instrumentRef: instrumentRef
    }
    if (instrumentRef && checkoutToken && shopperRef) {
      dispatch(deleteSavedInstruments({ checkoutToken, shopperRef, instrumentRef, payload }))
    }
  }

  useEffect(() => {
    if (!sessionDetailsLoaded) return
    if (!isEmpty(deletedInstrument)) {
      let checkoutToken = sessionDetails?.token;
      dispatch(getSavedIntsruments({ checkoutToken: checkoutToken, shopperRef }));
      dispatch(removeDeletedInstrument());
      setIsDeleteConfirmationModalOpen(false)
    }
  }, [deletedInstrument])


  const OfferText = ({ label = "LOW_COST_EMI_AVAILABLE", labelText = "Low-Cost EMI available" }) => {
    return (
      <div className="offerTextShow">
        <div className="no-cost-emi">
          <Typography className="no-cost-text">
            <TranslateText label={label}>{labelText}</TranslateText>
          </Typography>
        </div>
      </div>
    )
  }

  // Saved-card tile (mobile + web): logo box, nickname, masked number | CVV Less, chevron.
  const getMobileCardContent = (paymentInfo, idx) => {
    const last4 = paymentInfo?.displayValue?.slice(-4);
    const brandName = paymentInfo?.displayValue?.replace(/[\s*\d]+$/, "").trim() || paymentInfo?.brand;
    const nickName = paymentInfo?.cardNickName;
    const hasValidNickName = nickName && !/\b(null|undefined)\b/i.test(nickName);
    const rawTitle = hasValidNickName ? nickName : `${paymentInfo?.issuers || brandName} Card`;
    const title = rawTitle.charAt(0).toUpperCase() + rawTitle.slice(1);
    const isCvvLess = Array.isArray(paymentInfo?.requiredInputs) && paymentInfo.requiredInputs.length === 0;
    const isSelected = selectedIntrumentIdx === idx;

    return (
      <div
        className="saved-card-tile"
        style={{
          borderBottom: idx !== data?.length - 1 && "1px solid rgba(0, 0, 0, 0.06)",
        }}
        onClick={() => {
          dispatch(updateSelectedInstruments(paymentInfo));
          dispatch(handleTotalPaymentSummaryError(""));
        }}
      >
        <div className="saved-card-tile-logo" style={isSelected ? { borderColor: baseColor } : undefined}>
          {paymentInfo?.logoUrl && <img src={paymentInfo.logoUrl} alt={brandName} />}
        </div>
        <div className="saved-card-tile-info">
          <Typography className="saved-card-tile-title dynamic-font-family">{title}</Typography>
          <Typography className="saved-card-tile-sub dynamic-font-family">
            {`**** ${last4}`}
            {isCvvLess && (
              <>
                {" | "}
                <span className="saved-card-tile-cvvless">
                  <TranslateText label={"CVV_LESS"}>CVV Less</TranslateText>
                </span>
              </>
            )}
          </Typography>
        </div>
        <div className="saved-card-tile-actions">
          {paymentInfo?.instrumentRef && (
            <img
              src="/assets/others/delete.png"
              width={18}
              style={{ cursor: "pointer", display: "block" }}
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteInstrumentClick(paymentInfo);
              }}
            />
          )}
          <span className="saved-card-tile-indicator">
            {isSelected ? (
              <CheckCircleFilled style={{ color: baseColor, fontSize: "20px" }} />
            ) : (
              <RightOutlined style={{ color: baseColor, fontSize: "14px" }} />
            )}
          </span>
        </div>
      </div>
    );
  };

  const getContent = (paymentInfo, idx) => {
    if (paymentInfo?.type === "Card") {
      return getMobileCardContent(paymentInfo, idx);
    }
    let displayValue = '';
    if (paymentInfo.type === 'Card') {
      const last4 = paymentInfo?.displayValue.slice(-4);
      displayValue = `******${last4}`;
    } else {
      displayValue = paymentInfo.displayValue
    }

    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: paymentInfo?.instrumentRef ? "90% 10%" : "auto",
          alignItems: 'center',
          borderBottom: idx !== data?.length - 1 && "1px dashed rgba(0, 0, 0, 0.06)",
        }}
      >
        <div
          className="domestic-pi-item"
          onClick={() => {
            dispatch(updateSelectedInstruments(paymentInfo));
            dispatch(handleTotalPaymentSummaryError(""));
          }}
        >
          <div className="domestic-pi-title-logo">
            {paymentInfo?.brand === "CreditCardEMI" ||
              (paymentInfo?.brand === "DebitCardEMI" ? (
                ""
              ) : (
                <>
                  {paymentInfo?.logoUrl && (
                    <img
                      src={paymentInfo?.logoUrl}
                      style={{ width: "20px", height: "20px" }}
                    />
                  )}
                </>
              ))}

            {paymentInfo?.type === "Emi" &&
              paymentInfo?.brand === "CardlessEMI" ? (
              <Typography className="domestic-pi-header dynamic-font-family">
                {paymentInfo?.emiMethod?.cardlessEmiProviderTitle}
              </Typography>
            ) : paymentInfo?.type === "Emi" &&
              (paymentInfo?.brand === "CreditCardEMI" ||
                paymentInfo?.brand === "DebitCardEMI") ? (
              <div>
                <Typography
                  className="domestic-pi-header dynamic-font-family"
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  {paymentInfo?.emiMethod?.duration} <TranslateText label={"MONTHS"}>months</TranslateText> {' x '}
                  <span className="planDetailsText">
                    {" "}
                    {currencyCode}
                  </span>
                  {numberToCurrency(paymentInfo?.emiMethod?.emiAmount, currencyCode)} {' | '}
                  {paymentInfo?.emiMethod?.effectiveInterestRate}%{' p.a'}
                </Typography>
                {paymentInfo?.emiMethod?.applicableOffer ? (
                  paymentInfo?.emiMethod?.applicableOffer?.discount?.type ===
                    "LowCostEmi" ? (
                    <OfferText label="LOW_COST_EMI_AVAILABLE" labelText="Low-Cost EMI available" />
                  ) : paymentInfo?.emiMethod?.applicableOffer?.discount
                    ?.type === "NoCostEmi" ? (
                    <OfferText label="NO_COST_EMI_AVAILABLE" labelText="No-Cost EMI available" />
                  ) : ("")
                ) : ("")
                }
              </div>
            ) : (
              <Typography className="domestic-pi-header dynamic-font-family">
                {paymentInfo?.issuers && paymentInfo.issuers} {paymentInfo?.title || displayValue}
              </Typography>
            )}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <CheckCircleFilled
              style={{
                color: selectedIntrumentIdx === idx ? baseColor : "#ECECED",
                fontSize: "24px",
              }}
            />

            {
              paymentInfo?.instrumentRef && <img src="/assets/others/delete.png" width={20} style={{ cursor: 'pointer', display: 'block', justifySelf: 'center' }} onClick={() => handleDeleteInstrumentClick(paymentInfo)} />
            }

          </div>
        </div>


        {/* <DeleteTwoTone
          style={{
            color: sessionDetails?.merchantDetails?.checkoutTheme?.headerColor,
            // color: selectedIntrumentIdx === idx ? baseColor : "#ECECED",
            fontSize: "24px",
          }}
        /> */}
        {selectedInstrument &&
          selectedInstrument?.type === "Emi" &&
          selectedInstrument?.brand !== "CardlessEMI" &&
          selectedInstrument?.emiMethod?.duration ===
          paymentInfo?.emiMethod?.duration && (
            <EmiPlanDetails emiMethodInfo={selectedInstrument} paymentInfo={paymentInfo} />
          )}
      </div>
    );
  };

  const options = [];
  const topBanks = TOP_BANKS;

  data?.map((val, idx) => {
    options.push({
      label: val?.title || val?.displayValue,
      value: val?.title,
    });
  });
  useEffect(() => {
    if (options.length === 1 && isEmpty(selectedInstrument)) {
      let method = data?.find(
        (paymentInfo) =>
          (paymentInfo?.title || paymentInfo?.displayValue) === options[0]?.label
      );
      dispatch(updateSelectedInstruments(method));
    }
  }, [options]);

  useEffect(() => {
    if (
      selectedInstrument !== null &&
      selectedInstrument?.brand === "CardlessEMI"
    ) {
      dispatch(handleEmiPayButton(false));
    }
  }, [selectedInstrument]);

  useEffect(() => {
    if (selectedInstrument) {
      const paymentType = selectedInstrument?.type;
      const paymentSubType = selectedInstrument?.brand;
      methodSelectedEvent(paymentType, paymentSubType);
    }
  }, [selectedInstrument])

  return (
    <div className="domestic-pi-selection-root">
      {data?.map((paymentInfo, idx) => {
        if (paymentInfo?.type === "NetBanking" && !topBanks?.find((title) => title === paymentInfo?.title)) {
          return null;
        }
        return (
          <div key={idx}>
            {getContent(paymentInfo, idx)}
          </div>
        );
      })}
      {afterList}
      {
        (activePaymentMethod === 'Card' || (showUpiPayButton && activePaymentMethod === 'Upi' && data?.length > 0)) && !isMobileLayout && (
          <div style={{ marginTop: '0.5rem' }}>
            <PyamentButton />
          </div>
        )
      }
      {!isMobileLayout &&
        data?.length > 0 &&
        data[0]?.type === "NetBanking" && (
          <div style={{}}>
            <Typography
              className="regular14Heading dynamic-font-family"
              style={{ color: "var(--Neutral-Grey-1000)" }}
            >
              <TranslateText label={"ALL_BANKS"}>All Banks</TranslateText>
            </Typography>
          </div>
        )}

      {searchComponent && (
        <div style={{ marginTop: "12px" }}>
          <Select
            showSearch
            style={{ width: "100%" }}
            placeholder={searchPlaceholder}
            options={options}
            value={selectedInstrument?.title}
            onChange={(value) => {
              let method = data?.find(
                (paymentInfo) => paymentInfo?.title === value
              );
              dispatch(updateSelectedInstruments(method));
            }}
          />
        </div>
      )}

      <ConfirmationModal
        icon={
          <CloseCircleOutlined style={{ color: "#FAAD14", fontSize: "22px" }} />
        }
        title={`${t("DELETE_INSTRUMENT")}?`}
        desc={`${t("DELETE_INSTRUMENT_CONFIRMATION")} ${deleteInstrumentData?.displayValue}?`}
        showModal={isDeleteConfirmationModalOpen}
        primaryOnClick={() => handleDeleteConfirmation()}
        secondaryOnClick={() => { deleteSavedCardModalClosedEvent(); setIsDeleteConfirmationModalOpen(false); setDeleteInstrumentData(undefined) }}
        primaryBtnText={t("YES")}
        secondaryBtnText={t("NO")}
        showSecondaryButton={true}
        isPrimaryButtonLoading={deleteInstrumentsLoading}
      />
      {/* <ConfirmationModal isOpen={isDeleteConfirmationModalOpen} setIsOpen={setIsDeleteConfirmationModalOpen} /> */}
    </div>
  );
};

export default PaymentIntrumentSelection;
